import React, { PropsWithChildren } from 'react';
import { Box, Tooltip, Typography, TypographyProps } from '@mui/material';

export function ContextToolbarContainer({ children }: PropsWithChildren) {
  return (
    <Box
      sx={{
        display: 'flex',
        minWidth: 0,
        alignItems: 'center',
        paddingX: { xs: 1, xl: 6 },
      }}
    >
      {children}
    </Box>
  );
}

export function ContextToolbarTitle({ children, ...typographyProps }: TypographyProps) {
  return (
    <Tooltip title={children}>
      <Typography
        {...typographyProps}
        variant="h5"
        sx={{
          fontSize: '1.5em',
          paddingX: 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {children}
      </Typography>
    </Tooltip>
  );
}
